import { Node, NodeProps } from "@xyflow/react";
import { useSetAtom } from "jotai";
import {
  assetStepTitlePlaceholderTextAtom,
  DefaultNodeData,
} from "@zapier/canvas-state";
import {
  DEFAULT_TABLE_NODE_BACKGROUND_COLOR,
  DEFAULT_TABLE_NODE_COLOR,
} from "@zapier/canvas-constants";

import { AssetNodeProps } from "../AssetNodeSkeleton/AssetNodeDeterminer";
import { AssetNodeSkeleton } from "../AssetNodeSkeleton";
import { useAssetPreload } from "../../../../hooks/useAssetPreload";

export function TableNode(
  props: NodeProps<Node<DefaultNodeData>> & AssetNodeProps,
) {
  const { isViewOnlyMode } = props;

  const handleMouseEnter = useAssetPreload({
    assetType: "table",
    nodeData: props.data,
  });
  const getPlaceholder = useSetAtom(assetStepTitlePlaceholderTextAtom);
  const placeholder = getPlaceholder("table");
  return (
    <AssetNodeSkeleton
      {...props}
      data={{
        ...props.data,
        color: props.data.color || DEFAULT_TABLE_NODE_COLOR,
      }}
      placeholder={isViewOnlyMode ? "" : placeholder}
      iconName="navTables"
      backgroundColor={
        props.backgroundColor || DEFAULT_TABLE_NODE_BACKGROUND_COLOR
      }
      onMouseEnter={handleMouseEnter}
    />
  );
}
